import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Container } from '@mui/material';
import theme from './theme';
import { CartProvider } from './context/CartContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ProductList from './components/ProductList';
import ProductDetail from './components/ProductDetail';
import Cart from './components/Cart';
import Confirmation from './components/Confirmation';
import Admin from './components/Admin';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { useLocation } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { CartContext } from './context/CartContext';
import axios from 'axios';

function AppContent() {
  const { clearCart } = useContext(CartContext);
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin') || location.pathname === '/login';

  useEffect(() => {
    const pendingOrderId = localStorage.getItem('pendingOrderId');
    if (pendingOrderId) {
      axios.get(`/api/transaction-status/${pendingOrderId}`)
        .then(response => {
          if (response.data.status === 'COMPLETED') {
            clearCart();
            localStorage.removeItem('pendingOrderId');
          }
        })
        .catch(err => {
            if (err.response && err.response.status === 404) {
                // If it's not found, maybe it's too old or was never created properly
                // But typically it should be there if we have the ID.
                // We'll leave it for now.
            }
            console.error('Error checking pending order status:', err);
        });
    }
  }, [clearCart]);

  return (
    <>
      <Navigation />
      <Container sx={{ mt: 4, mb: 10 }}>
        <Routes>
          <Route path="/" element={<ProductList />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedRoute />}>
            <Route path="" element={<Admin />} />
          </Route>
        </Routes>
      </Container>
      {!isAdminPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <CartProvider>
          <AppContent />
        </CartProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
